import { MonitorType } from '../../../shared/types/monitor/MonitorType';

/** Dashboard names of the processed models (no version suffixes — the versions change, the channel doesn't). */
export const MODEL_LABELS: Partial<Record<MonitorType, string>> = {
  GPT_API_BROWSER: 'GPT API Search',
  GPT_SEARCH_BROWSER: 'GPT Search',
  CLAUDE_API: 'Claude',
  DEEP_SEEK_API: 'DeepSeek',
  PERPLEXITY_API: 'Perplexity API Search',
  PERPLEXITY_SEARCH_BROWSER: 'Perplexity Search',
  GROK_API: 'Grok API',
  COPILOT_SEARCH_BROWSER: 'Copilot',
  GEMINI_SEARCH_BROWSER: 'Gemini Search',
  AI_OVERVIEW_NEW: 'AI Overview',
  AI_MODE: 'AI Mode',
};
